
import { useQuery } from '@tanstack/react-query';
import { PaymentService } from '@/services/payment';
import { Payment } from '@/services/payment/types';

/**
 * Hook to fetch payment history for a specific family
 * @param familyId The ID of the family to fetch payments for
 * @returns Query result with payment data
 */
export const useFamilyPayments = (familyId: string) => {
  return useQuery<Payment[], Error>({
    queryKey: ['family-payments', familyId],
    queryFn: () => PaymentService.getRecentPayments(familyId),
    enabled: !!familyId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2, // Retry failed requests twice
    refetchOnWindowFocus: false, // Don't refetch when window gains focus
  });
};
